import {Component, Inject} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DatePipe} from "@angular/common";
import {InspectionDraftService} from "../../services/inspection-draft.service";
import {DraftInspection} from "../../../../models/inspection.model";
import {EditInspectionDialogData} from "../edit-inspection-dialog/edit-inspection-dialog.component";
import {InspectionService} from "../../services/inspection.service";
import {NotificationService} from "../../../shared/services/notification.service";
import {TranslateService} from "@ngx-translate/core";
import {finalize} from "rxjs";

@Component({
    selector: 'app-create-inspection-dialog',
    templateUrl: './create-inspection-dialog.component.html',
    styleUrls: ['./create-inspection-dialog.component.scss']
})
export class CreateInspectionDialogComponent {
    form: FormGroup;
    draftInspection: DraftInspection | null = null;
    isEditMode: boolean = false;
    todayDate = new Date();
    isLoading: boolean = false;

    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<CreateInspectionDialogComponent>,
        private datePipe: DatePipe,
        private inspectionDraftService: InspectionDraftService,
        private inspectionService: InspectionService,
        private notificationService: NotificationService,
        private translateService: TranslateService,
        @Inject(MAT_DIALOG_DATA) public data: EditInspectionDialogData,
    ) {
        this.isEditMode = !!data.isEditMode;
        this.draftInspection = this.inspectionDraftService.getDraft();
        this.form = this.fb.group({
            inspectionDate: [this.draftInspection.inspectionDate || new Date(), Validators.required],
            notes: [this.draftInspection.notes]
        });
    }

    onCancel(): void {
        this.dialogRef.close(null);
    }

    onSave(): void {
        if (this.form.valid) {
            const formValue = this.form.value;
            const formattedDate = this.datePipe.transform(formValue.inspectionDate, 'yyyy-MM-dd');

            // Vérifier si une inspection existe déjà à cette date pour ce point
            this.isLoading = true;
            this.inspectionService.checkInspectionExists(this.data.point.id, formattedDate)
                .pipe(finalize(() => this.isLoading = false))
                .subscribe({
                    next: (response) => {
                        if (response.exists) {
                            // Si une inspection existe déjà et que nous ne sommes pas en mode édition
                            // ou si nous sommes en mode édition mais pour une inspection différente
                            if (!this.isEditMode || (this.isEditMode && this.draftInspection &&  this.draftInspection.inspectionDate !== formattedDate)) {
                                this.notificationService.warning(this.translateService.instant('pages.createInspectionDialog.inspectionExistsError'));
                            } else {
                                // Si c'est la même date que l'inspection en cours d'édition, on continue
                                formValue.inspectionDate = formattedDate;
                                this.dialogRef.close(formValue);
                            }
                        } else {
                            // Aucune inspection n'existe à cette date, on peut continuer
                            formValue.inspectionDate = formattedDate;
                            this.dialogRef.close(formValue);
                        }
                    },
                    error: (err) => {
                        console.error(err);
                        this.notificationService.error(
                            this.translateService.instant('common.errors.unknownError')
                        );
                    }
                });
        }
    }
}
